import { observer } from "mobx-react";
import { IValidationGroup } from "../../../../../../../hooks/validation-group/validation-group-hook";
import ApiKeyField from "../fields/api-key-field/api-key-field";
import { FormFieldLine } from "../../../../../../../components/form-field-line/form-field-line";
import { Input } from "../../../../../../../components/inputs/input/input";
import FedexCredentialsStore from "../../../../stores/credentials/shipping/fedex-credentials-store";

interface IProps {
    credentialsStore: FedexCredentialsStore;
    vGroup: IValidationGroup;
    apiKeyLabel?: string;
    apiKeyNote?: string;
    apiSecretLabel?: string;
    apiSecretNote?: string;
    customerNumberLabel?: string;
    customerNumberNote?: string;
}

const FedexCredentials: React.FC<IProps> = observer(
    ({ credentialsStore, vGroup, apiKeyLabel, apiKeyNote }) => {
        return (
            <>
                <ApiKeyField
                    credentialsStore={credentialsStore}
                    validationGroup={vGroup}
                    label={apiKeyLabel}
                    note={apiKeyNote}
                />
                <FormFieldLine
                    label="FedEx Webservice Client ID"
                    key="webserviceClientId"
                    note="FedEx Webservice API Client ID. Required only for using SMART POST (FedEx Ground Economy) Service"
                >
                    <Input
                        value={credentialsStore.webserviceClientId}
                        onChange={credentialsStore.setWebserviceClientId}
                        validationGroup={vGroup}
                        type="password"
                        autoComplete="new-password"
                    />
                </FormFieldLine>
                <FormFieldLine
                    label="FedEx Webservice Client Secret"
                    key="webserviceClientSecret"
                    note="FedEx Webservice API Client Secret. Required only for using SMART POST (FedEx Ground Economy) Service"
                >
                    <Input
                        value={credentialsStore.webserviceClientSecret}
                        onChange={credentialsStore.setWebserviceClientSecret}
                        validationGroup={vGroup}
                        type="password"
                        autoComplete="new-password"
                    />
                </FormFieldLine>
            </>
        );
    }
);

export default FedexCredentials;
